import { FC, ReactNode } from 'react';

import { PlayVideoContext } from '../contexts/PlayVideoContext';
import { usePlayingState } from './playingState';

export const ModalVideoContainer: FC<{ children: ReactNode }> = ({ children }) => {
  const status = usePlayingState();
  return <PlayVideoContext.Provider value={status}>{children}</PlayVideoContext.Provider>;
};
